
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Breadcrumb } from "@components/breadcrumb";
import { NextSeo } from "@components/seo";
import { getAllPergolasPathsById, getPergolaBySlug } from "@utils/get-products";
import parse from "html-react-parser";
import Image from "next/image";
import type { GetStaticPaths, GetStaticProps, NextPage } from "next/types";
interface IPage {
    product: {
        title: string;
        content: string;
        featuredImage: {
            node: {
                sourceUrl: string;
                mediaDetails: {
                    height: number;
                    width: number;
                };
            };
        };
        pergolasPage: {
            text1: string;
            text2: string;
            text3: string;
            image: {
                sourceUrl: string;
                mediaDetails: {
                    height: number;
                    width: number;
                };
            };
            fourimages: {
                image: {
                    sourceUrl: string;
                    mediaDetails: {
                        height: number;
                        width: number;
                    };
                };
            }[];
            twoimages: {
                image: {
                    sourceUrl: string;
                    mediaDetails: {
                        height: number;
                        width: number;
                    };
                };
            }[];
        };
    };
}
const PergolasPage: NextPage<IPage> = ({ product }) => {
    return (<>
      <NextSeo languageAlternates={[
            { href: "https://knsokna.pl/pergolas", hrefLang: "x-default" },
            { href: "https://knswindows.com/pergolas", hrefLang: "en" },
            { href: "https://knsokna.pl/pergolas", hrefLang: "pl" },
            { href: "https://knsfenster.de/pergolas", hrefLang: "de" },
            { href: "https://kns-okna.eu/pergolas", hrefLang: "cs" },
            { href: "https://knsfinestre.it/pergolas", hrefLang: "it" },
            { href: "https://knsfenetres.fr/pergolas", hrefLang: "fr" },
            { href: "https://knsokna.eu/pergolas", hrefLang: "hu" },
        ]}/>

      <div className="bg-white">
        <div className="mx-auto mt-3 max-w-7xl px-4 sm:px-6">
          <Breadcrumb product={product?.title}/>
          <h1 className="mb-2 bg-gradient-to-r from-red to-orange p-1 font-bold text-3xl text-white">
            {/* {product?.title ? product?.title : product?.en?.title} */}
            {product?.title}
          </h1>
          <Image alt={product?.title} height={product?.featuredImage?.node?.mediaDetails?.height} src={product?.featuredImage?.node?.sourceUrl} width={product?.featuredImage?.node?.mediaDetails?.width}/>
          <h1 className="pt-8 pb-3 font-bold text-3xl uppercase">
            {product?.title}
          </h1>
          <div>{parse(product?.content || "")}</div>
          <div className="grid grid-cols-2 gap-4 px-4 py-8 md:grid-cols-4 md:px-0">
            {product?.pergolasPage?.fourimages?.map((image) => (<div key={image.image.sourceUrl}>
                <Image alt={product?.title} height={product?.pergolasPage?.image?.mediaDetails?.height} src={image?.image?.sourceUrl} width={product?.pergolasPage?.image?.mediaDetails?.width}/>
              </div>))}
          </div>
          <div>{parse(product?.pergolasPage?.text1 || "")}</div>
          <div className="grid grid-cols-1 gap-4 px-4 py-8 md:grid-cols-2 md:px-0">
            {product?.pergolasPage?.twoimages?.map((image) => (<div key={image.image.sourceUrl}>
                <Image alt={product?.title} height={product?.pergolasPage?.image?.mediaDetails?.height} src={image?.image?.sourceUrl} width={product?.pergolasPage?.image?.mediaDetails?.width}/>
              </div>))}
          </div>
          <div>{parse(product?.pergolasPage?.text2 || "")}</div>
          <div className="px-4 py-8 md:px-20 lg:px-48">
            <Image alt={product?.title} height={product?.pergolasPage?.image?.mediaDetails?.height} src={product?.pergolasPage?.image?.sourceUrl} width={product?.pergolasPage?.image?.mediaDetails?.width}/>
          </div>
          <div>{parse(product?.pergolasPage?.text3 || "")}</div>
        </div>
      </div>
    </>);
};
export const getStaticPaths: GetStaticPaths = async () => {
    // const PATHS_IDS = Object.values(PVC.WINDOWS.VEKA);
    const { paths: path } = await getAllPergolasPathsById();
    const paths = path.map((p: {
        slug: string;
        databaseId: string;
        language: {
            code: string;
        };
    }) => ({
        locale: p.language.code.toLowerCase(),
        params: {
            slug: `${p.slug}-${p.databaseId}`,
        },
    }));
    // console.log('paths', paths);
    return {
        fallback: "blocking",
        paths,
    };
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const _LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    // const PAGE_ID = PAGE.PERGOLAS[LOCALE as keyof typeof PAGE.PERGOLAS] || 1;
    const slug = context.params?.slug as string;
    const PRODUCT_ID = slug.split("-").pop() as string;
    const { product } = await getPergolaBySlug(PRODUCT_ID);
    if (!product) {
        return { notFound: true };
    }
    return {
        props: {
            product,
        },
    };
};
export default PergolasPage;

    async function __Next_Translate__getStaticProps__1a19cd2bf23__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pergolas/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bf23__ as getStaticProps }
  